import { SharingDialog } from './';
import { connect } from 'react-redux';
import { 
  namespace as userManagmentNamespace, 
  loadOrgUsers, 
  loadTeams 
} from '../../state/modules/app/userManagement/actions';
import {
  namespace as dialogNameSpace,
  Status as dialogStatus,
  closeDialog
} from '../../state/modules/app/dialogStatus/actions';
import { DIALOG_SHARE_ADVERTISER } from '../../helpers/constant';
import { get } from 'lodash';
import { loadAdvertisers, namespace as advertiserNameSpace, updateAdvertiserPermission } from '../../state/modules/app/advertiser';

const ShareAdvertiserDialog = connect(
  state => {
    const openStatus = get(state, [dialogNameSpace, 'dialogs', DIALOG_SHARE_ADVERTISER, 'status']);
    const id = get(state, [dialogNameSpace, 'dialogs', DIALOG_SHARE_ADVERTISER, 'value']);
    const currentAdvertiser = get(state, [advertiserNameSpace, 'byId', id], {});
    const advertiserLoadStatus = get(state, [advertiserNameSpace, 'status']);
    const entityName = get(currentAdvertiser, 'advertiser_name', 'this advertiser');
    const currentUserId = get(state, 'user.user.userId');
    const ownerId = get(currentAdvertiser, 'owner', '');
    const editors = get(currentAdvertiser, 'editors', []);
    const viewers = get(currentAdvertiser, 'viewers', []);
    const users = get(state, [userManagmentNamespace, 'users', 'data'], []);
    const teams = get(state, [userManagmentNamespace, 'teams', 'data'], []);
    const userLoadStatus = get(state, [userManagmentNamespace, 'users', 'status']);
    const teamLoadStatus = get(state, [userManagmentNamespace, 'teams', 'status']);

    const usersHashMap = users.reduce((accum, user) => {
      if (user.id) {
        accum[user.id] = {...user};
      }
      return accum;
    }, {});

    const memberManagerHashMap = teams && teams.reduce((accum, currentTeam) => {
      const { memberIds, managerIds} = currentTeam;
      memberIds && memberIds.forEach( id => {
        if(!accum[id]) {
          accum[id] = [];
        }
        accum[id] = [...accum[id], ...managerIds];
      });
      return accum;
    }, {});
    
    const currentUser = usersHashMap[currentUserId];
    if (currentUser) {
      currentUser.isCurrentUser = true;
    }

    return {
      id,
      dialogName: DIALOG_SHARE_ADVERTISER,
      label: 'Share Advertiser',
      open: openStatus === dialogStatus.STATUS_OPEN,
      entityName,
      ownerId,
      editors,
      viewers,
      currentUserId,
      users,
      usersHashMap,
      teams,
      userLoadStatus,
      teamLoadStatus,
      memberManagerHashMap,
      advertiserLoadStatus
    }
  },
  {
    loadOrgUsers,
    loadTeams,
    loadAdvertisers,
    onChange: updateAdvertiserPermission,
    onClose: closeDialog
  }
)(SharingDialog);

export default ShareAdvertiserDialog;
